export default __webpack_public_path__ + "static/media/daedelmare3.43df5932.jpg";